import React from 'react';
import { motion } from 'framer-motion';
import { BotIcon, CalendarCheckIcon } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-navy relative dot-pattern" data-id="element-175">
      <div className="max-w-7xl mx-auto px-6" data-id="element-176">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-177">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-178">
            Conoce CONECKTA
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-muted leading-relaxed" data-id="element-179">
            Un asistente de IA, creado a la imagen de tu negocio, que responde a
            cada interesado, lo califica y agenda citas en tu calendario — para
            que tú te enfoques en crecer, no en perseguir.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-180">
          {/* macOS style window */}
          <div className="bg-surface border border-primary/20 rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(0,180,216,0.1)]" data-id="element-181">
            {/* Window Header */}
            <div className="bg-navy-deep px-4 py-3 border-b border-primary/10 flex items-center justify-between" data-id="element-182">
              <div className="flex gap-2" data-id="element-183">
                <div className="w-3 h-3 rounded-full bg-red-500/80" data-id="element-184" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/80" data-id="element-185" />
                <div className="w-3 h-3 rounded-full bg-green-500/80" data-id="element-186" />
              </div>
              <div className="text-xs font-medium text-muted" data-id="element-187">CONECKTA AI</div>
              <div className="w-12" data-id="element-188" /> {/* Spacer for centering */}
            </div>

            {/* Chat Area */}
            <div className="p-6 md:p-8 space-y-6 bg-surface/50" data-id="element-189">
              {/* Client Message */}
              <div className="flex justify-end" data-id="element-190">
                <div className="bg-navy-deep border border-primary/10 text-white px-5 py-3 rounded-2xl rounded-tr-sm max-w-[80%] text-sm md:text-base" data-id="element-191">
                  Hola, vi su anuncio y me gustaría saber más sobre sus
                  servicios.
                </div>
              </div>

              {/* AI Message */}
              <div className="flex items-start gap-3" data-id="element-192">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center shrink-0 mt-1" data-id="element-193">
                  <BotIcon className="w-5 h-5 text-primary" data-id="element-194" />
                </div>
                <div className="space-y-4 max-w-[80%]" data-id="element-195">
                  <div className="bg-primary/10 border border-primary/20 text-white px-5 py-3 rounded-2xl rounded-tl-sm text-sm md:text-base" data-id="element-196">
                    ¡Hola! Claro que sí. Para darte la mejor información, ¿qué
                    día te gustaría agendar una breve llamada de descubrimiento?
                  </div>

                  {/* Appointment Card */}
                  <div className="bg-navy-deep border border-primary/30 rounded-xl p-4 flex items-center gap-4 shadow-lg" data-id="element-197">
                    <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center shrink-0" data-id="element-198">
                      <CalendarCheckIcon className="w-5 h-5 text-primary" data-id="element-199" />
                    </div>
                    <div className="flex-1" data-id="element-200">
                      <h4 className="text-white font-semibold text-sm md:text-base" data-id="element-201">
                        Llamada de Descubrimiento
                      </h4>
                      <p className="text-muted text-xs md:text-sm" data-id="element-202">
                        Mañana, 10:00 AM - Zoom
                      </p>
                    </div>
                    <div className="px-3 py-1 bg-green-500/10 border border-green-500/20 text-green-400 text-xs font-medium rounded-full" data-id="element-203">
                      Cita Agendada
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}